import angular from 'angular';
import OrderDetailsApiService from './OrderDetailsApiService';


export default angular
  .module('resources.orderDetails', [])
  .service('OrderDetailsApiService', OrderDetailsApiService)
  .name;
